import React from "react";
import styles from "../styles/TestimonialsContainer.module.scss";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
// import { Link } from "react-router-dom";
import classNames from "classnames";

const TestimonialsContainer = ({ title }) => {
  const testimonialsArray = [
    {
      id: 1,
      text: "From the first email & call, everyone clearly knew what they were on about, true experts. ",
      customerName: "Mr. A R & Ms. N, S London",
    },
    {
      id: 2,
      text: "From the first email & call, everyone clearly knew what they were on about, true experts. ",
      customerName: "Mr. A R & Ms. N, S London",
    },
    {
      id: 3,
      text: "From the first email & call, everyone clearly knew what they were on about, true experts. ",
      customerName: "Mr. A R & Ms. N, S London",
    },
  ];
  return (
    <div className={styles.testimonialsContainer}>
      <p className={styles.header}>See What’s Our Customers Says</p>
      <div className={styles.testimonies}>
        {testimonialsArray.map((item) => {
          return (
            <div
              className={classNames(
                styles.testimony,
                title === "Bridging Loans"
                  ? styles.bLoans
                  : title === "Development Finance"
                  ? styles.dFinance
                  : title === "Stop Repossessions"
                  ? styles.sRepo
                  : title === "Resources"
                  ? styles.reSources
                  : ""
              )}
            >
              <p className={styles.text}>
                <FaQuoteLeft className={styles.leftIcon} /> {item.text}{" "}
                <FaQuoteRight className={styles.rightIcon} />
              </p>
              <p className={styles.customerName}>{item.customerName}</p>
            </div>
          );
        })}
      </div>
      {/* <Link
        to="#"
        className={classNames(
          styles.allReviewsLink,
          title === "Bridging Loans"
            ? styles.bLoans
            : title === "Development Finance"
            ? styles.dFinance
            : title === "Stop Repossessions"
            ? styles.sRepo
            : title === "Resources"
            ? styles.reSources
            : ""
        )}
      >
        See all customer reviews
      </Link> */}
    </div>
  );
};

export default TestimonialsContainer;
